import { CLEAR_REDUCERS, LOAD_TRACKING_RECORDS } from '../actions/actionTypes';

const initialState = [];

const trackingRecordsReducer = (state = [...initialState], action) => {
  switch (action.type) {
    case LOAD_TRACKING_RECORDS:
      state = [...action.payload];
      return [...state];
    case CLEAR_REDUCERS:
      state = [...initialState];
      return state;
    default:
      return state;
  }
};

export default trackingRecordsReducer;
